import React, { Component } from "react";
import "./App.css";
import Header from "./component/header.jsx";
import Footer from "./component/footer.jsx";
import { Nav, Ads, Product } from "./component/nav.jsx";
import Approuter from "./config/router";
class App extends Component {
    render() {
        return (
            <div>
                <Approuter />
                <Header />
                <Nav />
                <Ads />
                <Product />
                <Footer />
            </div>
        );
    }
}

export default App;
